import { AlertCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function OverlayError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation()
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: 32,
        textAlign: 'center',
      }}
    >
      <AlertCircle size={28} style={{ color: 'var(--destructive)' }} />
      <div style={{ fontSize: 14, color: 'var(--foreground)', fontWeight: 500 }}>
        {t('documents.detail.failedToLoadDocument')}
      </div>
      <div style={{ fontSize: 12, color: 'var(--muted-foreground)', maxWidth: 320 }}>
        {t('documents.detail.detailFetchError')}
      </div>
      <button
        type="button"
        onClick={onRetry}
        style={{
          marginTop: 6,
          padding: '7px 14px',
          borderRadius: '8px',
          border: '1px solid var(--border)',
          background: 'var(--card)',
          color: 'var(--foreground)',
          fontFamily: 'inherit',
          fontSize: 12,
          fontWeight: 500,
          cursor: 'pointer',
        }}
      >
        {t('documents.detail.retry')}
      </button>
    </div>
  )
}
